const UserAPI = {
  API_ROOT_URL: "/employee",
};

export default UserAPI;
